import { displayAloft } from "../displayAloftData";
import { displayEigenData } from "../displayEigenData";
import { displayOtherData } from "../displayOtherData";
import { displayCaddData } from "../displayCaddData";
import { displayDannData } from "../displayDannData";
import { getDbnsfpVersion } from "../InSilicoPredictionsHelpers";
import { displayVarsomePremiumDatabase } from "../../../../../common/helpers/helpers";
import * as constants from "../InSilicoPredictionsConstants";

export const renderRows = (
  dbList,
  schema,
  genome,
  variantResult,
  dbnsfp,
  dbnsfpPremium,
  cadd,
  dann,
  thresholds,
  sources
) => {
  const dbnsfpVersion = getDbnsfpVersion(dbnsfp);
  const displayCaddPremiumDB = displayVarsomePremiumDatabase("cadd", sources);
  return dbList.map((item) => {
    if (item.type === "dbItems" && !item.isMeta) {
      return displayOtherData(
        schema,
        genome,
        dbnsfp,
        item.prediction,
        item.name,
        item.prefix,
        item.url,
        item.thresholds,
        item.helptext
      );
    }

    if (item.type === "cadd") {
      return displayCaddData(cadd, thresholds, displayCaddPremiumDB);
    }

    if (item.type === "dann") {
      return displayDannData(dann, schema, variantResult, thresholds);
    }

    if (item.type === "aloft") {
      return displayAloft(dbnsfp, dbnsfpVersion, schema);
    }

    if (item.type === "eigen" || item.type === "eigenpc") {
      return displayEigenData(
        item.type,
        dbnsfp,
        dbnsfpVersion,
        schema,
        thresholds
      );
    }
    return null;
  });
};

export const getOrderDependingOfCategory = (type) => {
  if (constants.PREDICTION_PATHOGENIC_GROUP.includes(type)) {
    return 0;
  }

  if (constants.PREDICTION_UNCERTAIN_GROUP.includes(type)) {
    return 1;
  }

  if (constants.PREDICTION_BENIGH_GROUP.includes(type)) {
    return 2;
  }
  return -1;
};
